import { Component, Input, OnInit } from '@angular/core';
import { RenaultAnimationActionDetailDTO, RenaultAnimationActionRemuneration } from '../../../models/renault-animation-action-dto';
import { AnimationActionService } from 'src/app/services/animation-action.service';

@Component({
  selector: 'animation-action-card',
  templateUrl: './animation-action-card.component.html',
  styleUrls: ['./animation-action-card.component.scss']
})
export class AnimationActionCardComponent implements OnInit {

  @Input() model: RenaultAnimationActionDetailDTO;
  @Input() showRemuneration = false;
  totalRemuneration = 0;
  modelRemuneration: RenaultAnimationActionRemuneration;

  constructor(private service: AnimationActionService) { }

  ngOnInit(): void {
    this.getRemunerationPosition();
    this.calculateRemuneration();
  }

  calculateRemuneration() {
    const that = this;
    if (this.model.RenaultAnimationSubactions) {
      this.model.RenaultAnimationSubactions.forEach(function (subaction) {
        that.totalRemuneration += subaction.SoldTotalPrice;
      });
    }
  }

  getRemunerationPosition() {
    this.service.getRenaultAnimationActionRemuneration(this.model.IdAction).subscribe(res => {
      this.modelRemuneration = res;
    });
  }

}
